/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Tag, theme } from "@nordcloud/gnui";
import {
  APPROVAL_BADGE_TEXT_NO_DEADLINE,
  APPROVAL_BADGE_TEXT_PENDING,
  APPROVAL_BADGE_TEXT_PENDING_APPROVAL,
} from "./constants";
import { formatApprovalDuration } from "./formatApprovalDuration";
import { ApprovalBadgeKind, ApprovalBadgeMeta } from "./types";

type Props = {
  badgeMeta: ApprovalBadgeMeta;
  now: Date;
};

export function ApprovalBadge({ badgeMeta, now }: Props) {
  const isLeftTimeExpired =
    badgeMeta.kind === ApprovalBadgeKind.leftTime &&
    badgeMeta.expireAt.getTime() <= now.getTime();

  const approvalText = isLeftTimeExpired
    ? APPROVAL_BADGE_TEXT_PENDING_APPROVAL
    : getApprovalBadgeText(badgeMeta, now);

  return (
    <Tag
      text={approvalText}
      icon={badgeMeta.icon}
      color="purple"
      colorText="white"
      css={{
        display: "inline-flex",
        float: "none",
        margin: `0 0 0 ${theme.spacing.spacing03}`,
      }}
    />
  );
}

function getApprovalBadgeText(badgeMeta: ApprovalBadgeMeta, now: Date): string {
  let approvalText = APPROVAL_BADGE_TEXT_NO_DEADLINE;

  if (badgeMeta.kind === ApprovalBadgeKind.pending) {
    approvalText = APPROVAL_BADGE_TEXT_PENDING;
  } else if (badgeMeta.kind === ApprovalBadgeKind.leftTime) {
    const secondsLeft = Math.floor(
      (badgeMeta.expireAt.getTime() - now.getTime()) / 1000
    );
    approvalText = formatApprovalDuration(secondsLeft);
  }

  return approvalText;
}
